module.exports = __webpack_public_path__ + "static/media/chicken_with _sweet_cream_corn_soup.96bbe0bc.jpg";